import { render, staticRenderFns } from "./PublicationQuerySearch.vue?vue&type=template&id=fd997790"
import script from "./PublicationQuerySearch.vue?vue&type=script&lang=js"
export * from "./PublicationQuerySearch.vue?vue&type=script&lang=js"
import style0 from "./PublicationQuerySearch.vue?vue&type=style&index=0&id=fd997790&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports